import { render, staticRenderFns } from "./Juzgados.vue?vue&type=template&id=2997a668&"
import script from "./Juzgados.vue?vue&type=script&lang=js&"
export * from "./Juzgados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports